export default "__VITE_ASSET__3f96dc98__"